const steps = [
  {
    icon: 'ri-search-eye-line',
    title: 'Диагностика',
    description: 'Анализируем текущую ситуацию: интервью с руководителями, наблюдение за работой, сбор данных и показателей.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Адаптация программы',
    description: 'Настраиваем программу под специфику компании: отрасль, уровень сотрудников, конкретные бизнес-задачи.',
  },
  {
    icon: 'ri-flashlight-line',
    title: '80% практики',
    description: 'Минимум теории — максимум отработки. Ролевые игры, упражнения, бизнес-симуляции на реальных ситуациях.',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'Работа на кейсах компании',
    description: 'Разбираем реальные рабочие ситуации участников. Никаких абстрактных примеров — только то, с чем сталкиваются ежедневно.',
  },
  {
    icon: 'ri-file-edit-line',
    title: 'Домашние задания',
    description: 'Между модулями участники применяют навыки на рабочем месте и получают обратную связь от тренера.',
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Сопровождение',
    description: 'После обучения — консультации, разбор сложных кейсов и трекинг прогресса в течение 1-3 месяцев.',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Измеримый результат',
    description: 'Фиксируем показатели до и после обучения. Предоставляем отчет с конкретными цифрами и рекомендациями.',
  },
];

export default function WhyProgramsWork() {
  return (
    <section id="why-works" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Почему наши программы работают
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            За 18+ лет мы выработали методологию, которая гарантирует не просто передачу знаний, а реальное изменение поведения сотрудников и измеримый бизнес-результат.
          </p>
        </div>

        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-12 left-[7%] right-[7%] h-1 bg-teal-200 rounded-full"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-4 lg:gap-0">
            {steps.map((step, index) => (
              <div key={step.title} className="flex flex-col items-center text-center lg:px-3">
                {/* Step circle */}
                <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-md border-4 border-teal-100 mb-5 relative z-10">
                  <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center">
                    <i className={`${step.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                {/* Arrow for mobile */}
                {index < steps.length - 1 && (
                  <div className="lg:hidden flex justify-center mb-4">
                    <i className="ri-arrow-down-line text-2xl text-teal-300"></i>
                  </div>
                )}
                <h3 className="text-base font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}